import StaysSuccess from './StaysSuccess';

export default StaysSuccess;
